module.exports = __webpack_public_path__ + "static/media/logo.efb3e943.svg";